// @ts-nocheck
import { dapiFetchCache, dapiFetch, IDapiRequest } from '@origin-digital/daxi';

import {
  ISearchDataResponse,
  ISuggestDataResponse,
} from '../models';

/*
 * This code has been generated from an OpenAPI spec.
 */

export interface ISearchRequest {
  q: string;
  isNative: boolean;
  page?: number;
  pageSize?: number;
  filter?: string;
}

/**

 */
export const search = async (baseUrl: string, data: ISearchRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<ISearchDataResponse> => {
    try {
        const method = 'GET';
        const url = baseUrl + searchUrl();
        const params: any = data;
        const queryString = '?' + ['q','isNative','page','pageSize','filter',]
        .filter(k => params[k] !== undefined)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&');

        if (ttlInMin > 0) {
          const fetchOptions = { method, authorization, ttlInMin };
          const response = await dapiFetchCache<ISearchDataResponse>(url + queryString, fetchOptions);
          return response.data as ISearchDataResponse;
        }

        const fetchOptions = { method, authorization };
        const response = await dapiFetch<ISearchDataResponse>(url + queryString, fetchOptions);
        return response.data as ISearchDataResponse;
    } catch (error) {
        error.newRelic = `'GET: ${ searchUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the search endpoint url that substitutes in given url params.
  */
const searchUrl = () => {
    return '/api/search';
};


export interface ISuggestRequest {
  q: string;
  isNative: boolean;
}

/**

 */
export const suggest = async (baseUrl: string, data: ISuggestRequest, authorization?: IDapiRequest["authorization"], ttlInMin: number = 0): Promise<Array<ISuggestDataResponse>> => {
    try {
        const method = 'GET';
        const url = baseUrl + suggestUrl();
        const params: any = data;
        const queryString = '?' + ['q','isNative',]
        .filter(k => params[k] !== undefined)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&');

        if (ttlInMin > 0) {
          const fetchOptions = { method, authorization, ttlInMin };
          const response = await dapiFetchCache<Array<ISuggestDataResponse>>(url + queryString, fetchOptions);
          return response.data as Array<ISuggestDataResponse>;
        }

        const fetchOptions = { method, authorization };
        const response = await dapiFetch<Array<ISuggestDataResponse>>(url + queryString, fetchOptions);
        return response.data as Array<ISuggestDataResponse>;
    } catch (error) {
        error.newRelic = `'GET: ${ suggestUrl() }'`;
        throw error;
    }
};

/**
  * Generate a getter for the suggest endpoint url that substitutes in given url params.
  */
const suggestUrl = () => {
    return '/api/search/suggest';
};

